import { render, staticRenderFns } from "./ModalCadastroSmall.vue?vue&type=template&id=6900dc54&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ModalCadastroSmall.vue?vue&type=script&lang=js&"
export * from "./ModalCadastroSmall.vue?vue&type=script&lang=js&"
import style0 from "./ModalCadastroSmall.vue?vue&type=style&index=0&id=6900dc54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6900dc54",
  null
  
)

export default component.exports